// Initialize iJewel Mini Viewer containers within a root element.
function initIjewelViewers(root = document) {
  if (typeof ijewelViewer === 'undefined') return;

  root.querySelectorAll('[data-ijewel-model-id], [data-ijewel-model-url]').forEach((container) => {
    if (container.dataset.ijewelInitialized === 'true') return;
    container.dataset.ijewelInitialized = 'true';

    const viewerOptions = Object.assign(
      {
        showCard: false,
        hideQuality: true,
        brandingSettings: {
        showLoadingScreenLogo: true,
        enable: false,
        },
        // hideTryOn: false,
        showConfigurator: true,
        transparentBg: false,
      },
      window.iJewelViewerOptions || {
        
      },
    );

    if (container.dataset.ijewelModelId) {
      ijewelViewer.loadModelById(
        container.dataset.ijewelModelId,
        container.dataset.ijewelBasename || 'drive',
        container,
        viewerOptions,
      );
    } else {
      new ijewelViewer.Viewer(
        container,
        { modelUrl: container.dataset.ijewelModelUrl },
        viewerOptions,
      );
    }
  });
}

window.initIjewelViewers = initIjewelViewers;

document.addEventListener('shopify:section:load', (event) => {
  initIjewelViewers(event.target);
});

window.addEventListener('ijewel-viewer-ready', (event) => {
  requestAnimationFrame(() => {
    const app = event.detail?.viewer?.viewerApp;
    const viewer = app?.viewer;
    if (viewer?.renderer) {
      viewer.renderer.displayCanvasScaling = 0.20;
    }
    app?.resize?.();
  });
});
